import styled from 'styled-components';
import { isMobile } from '../../../common/utils';

export const PinInputWrapper = styled.div`
  display: flex;
  column-gap: ${isMobile ? 5 : 24}px;
  justify-content: center;
`;

export const PinInputDigit = styled.input`
  width: ${isMobile ? '100%' : '52px'};
  height: ${isMobile ? 'auto' : '52px'};
  text-align: center;
  font-size: 28px;
  line-height: ${isMobile ? 'auto' : '52px'};
  border: 2px solid var(--allie-color-neutral-40);
  border-radius: 4px;
  font-weight: 600;
  color: var(--allie-color-primary-60);
  outline: none;
  background-color: var(--allie-color-light-main)};
  padding-bottom: 5px;
`;

export const ShowPin = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  margin-top: 16px;
  width: fit-content;

  div:first-child {
    height: 20px;
  }

  ion-text {
    text-transform: none;
    margin-left: 8px;
  }
`;
